import { regionList } from '@/api/Layout/index.js'

let cached = null
let pending = null

export function loadRegionTree() {
  if (cached) return Promise.resolve(cached)
  if (pending) return pending
  pending = regionList().then((res) => {
    cached = (res && res.data) || []
    pending = null
    return cached
  }).catch((err) => {
    pending = null
    throw err
  })
  return pending
}

export function findNode(nodes, value) {
  const key = String(value)
  for (let i = 0; i < (nodes || []).length; i++) {
    const node = nodes[i]
    if (String(node.value) === key) return node
    if (node.children && node.children.length) {
      const hit = findNode(node.children, value)
      if (hit) return hit
    }
  }
  return null
}

export function labelsOfPath(nodes, values) {
  const labels = []
  let list = nodes || []
  ;(values || []).forEach((val) => {
    const hit = (list || []).find((item) => String(item.value) === String(val))
    if (!hit) return
    labels.push(hit.label)
    list = hit.children || []
  })
  return labels
}

export function displayOfPath(nodes, values) {
  if (!values || !values.length) return ''
  let list = nodes || []
  let last = null
  values.forEach((val) => {
    const hit = (list || []).find((item) => String(item.value) === String(val))
    if (!hit) return
    last = hit
    list = hit.children || []
  })
  if (!last) return ''
  return last.mername || labelsOfPath(nodes, values).join(' / ')
}

export function flattenOptions(nodes, pathVals, pathLabels) {
  const out = []
  const vals = pathVals || []
  const labels = pathLabels || []
  ;(nodes || []).forEach((node) => {
    const nextVals = vals.concat(node.value)
    const nextLabels = labels.concat(node.label)
    out.push({
      value: nextVals,
      label: nextLabels.join(' / '),
      mername: node.mername || nextLabels.join('')
    })
    if (node.children && node.children.length) {
      out.push(...flattenOptions(node.children, nextVals, nextLabels))
    }
  })
  return out
}
